import { IUser } from '~/models';
import { getAuthHeaders, tempMeeApi } from '~/services/api';

export interface IGetSelectedOfficeParams {
  /**
   * Forwarded as the `x-office` header. Omit during fresh signup when the
   * office id isn't known yet — the BE derives the office from the token.
   */
  officeId?: string;
  /**
   * Optional Authorization override. Pass the freshly-minted token during
   * signup when the redux store hasn't hydrated and `getAuthHeaders()`
   * would 401.
   */
  accessToken?: string;
}

async function getSelectedOffice(params: IGetSelectedOfficeParams = {}): Promise<IUser> {
  const baseHeaders = params.accessToken
    ? { Authorization: params.accessToken }
    : await getAuthHeaders();

  const response = await tempMeeApi.get<IUser>(`/auth/me`, {
    headers: {
      ...baseHeaders,
      ...(params.officeId ? { 'x-office': params.officeId } : {}),
    },
  });

  return response.data;
}

export const selectedOfficeApi = {
  getSelectedOffice,
};
